import { BidStatuses } from '../constants';

export const BidVerificationOutcomes = {
    Verified: {
        title: 'Carrier verified and accepted',
        badge: BidStatuses.Verified,
        color: 'success',
        icon: 'ri-checkbox-circle-fill',
    },
    Rejected: {
        title: 'Carrier rejected',
        badge: BidStatuses.Rejected,
        color: 'danger',
        icon: 'ri-close-circle-fill',
    },
    'Action Required': {
        title: 'Additional information required',
        badge: BidStatuses['Action Required'],
        color: 'warning',
        icon: 'ri-alert-line',
    },
    Verifying: {
        title: 'Verification in progress',
        badge: BidStatuses.Verifying,
        color: 'info',
        icon: 'ri-time-line',
    },
};

export const BidVerificationStepStates = {
    completed: {
        title: 'Completed',
        icon: 'ri-checkbox-circle-fill',
        className: 'text-success',
        connector: 'completed',
    },
    verified: {
        title: 'Verified',
        icon: 'ri-checkbox-circle-fill',
        className: 'text-success',
        connector: 'completed',
    },
    issues: {
        title: 'Issues found',
        icon: 'ri-error-warning-fill',
        className: 'text-danger',
        connector: 'issues',
    },
    in_review: {
        title: 'In review',
        icon: 'ri-error-warning-fill',
        className: 'text-warning',
        connector: 'review',
    },
    not_started: {
        title: 'Not started',
        icon: 'ri-checkbox-blank-circle-line',
        className: 'text-muted',
        connector: 'pending',
    },
    not_completed: {
        title: 'Not completed',
        icon: 'ri-indeterminate-circle-line',
        className: 'text-muted',
        connector: 'pending',
    },
};

export const BidCheckStatuses = {
    Verified: {
        title: 'Verified',
        className: 'badge-soft-success',
        icon: 'ri-checkbox-circle-fill',
        color: 'success',
    },
    Required: {
        title: 'Required',
        className: 'badge-soft-danger',
        icon: 'ri-error-warning-fill',
        color: 'danger',
    },
    'Needs info': {
        title: 'Needs info',
        className: 'badge-soft-warning',
        icon: 'ri-error-warning-line',
        color: 'warning',
    },
    Critical: {
        title: 'Critical',
        className: 'badge-soft-danger',
        icon: 'ri-close-circle-fill',
        color: 'danger',
    },
    High: {
        title: 'High',
        className: 'badge-soft-danger',
        icon: 'ri-error-warning-fill',
        color: 'danger',
    },
    Medium: {
        title: 'Medium',
        className: 'badge-soft-warning',
        icon: 'ri-alert-line',
        color: 'warning',
    },
};

export const BidDocumentStatuses = {
    Validated: { title: 'Validated', className: 'text-success', icon: 'ri-checkbox-circle-fill' },
    Valid: { title: 'Valid', className: 'text-success', icon: 'ri-checkbox-circle-fill' },
    Verified: { title: 'Verified', className: 'text-success', icon: 'ri-checkbox-circle-fill' },
    'Inconsistent data': { title: 'Inconsistent data', className: 'text-danger', icon: 'ri-error-warning-fill' },
    'Invalid document': { title: 'Invalid document', className: 'text-danger', icon: 'ri-error-warning-fill' },
    'Not matching': { title: 'Not matching', className: 'text-danger', icon: 'ri-close-circle-fill' },
};

export const BidSummaryTabs = [
    { key: 'live-verification', title: 'Live Verification' },
    { key: 'summary', title: 'Summary' },
    { key: 'documents', title: 'Documents Forensics' },
    { key: 'company', title: 'Company Intelligence' },
    { key: 'digital-identity', title: 'Digital Identity (Cyber Security)' },
    { key: 'human-identity', title: 'Human Identity (Call Verification)' },
];

export const DocumentForensicsOutcomes = {
    verified: {
        title: 'Verified',
        className: 'text-success',
        icon: 'ri-checkbox-circle-fill',
        color: 'success',
        likelihood: 0,
        likelihoodLabel: 'No forgery signals detected',
        note: 'Based on multiple AI forensics checks, no indicators of document manipulation were found. This does not guarantee authenticity but indicates low forgery risk.',
        signalCount: 0,
    },
    needs_review: {
        title: 'Needs review',
        className: 'text-warning',
        icon: 'ri-error-warning-fill',
        color: 'warning',
        likelihood: 20,
        likelihoodLabel: 'Low to moderate risk',
        note: 'Some inconsistencies were found that may indicate a risk of manipulation. Further review is recommended.',
        signalCount: 2,
    },
    rejected: {
        title: 'Rejected',
        className: 'text-danger',
        icon: 'ri-close-circle-fill',
        color: 'danger',
        likelihood: 78,
        likelihoodLabel: 'High likelihood of forgery',
        note: 'Multiple inconsistencies and anomalies indicate a high likelihood that this document is manipulated or fraudulent.',
        signalCount: 3,
    },
};

export const DocumentForensicsFilters = [
    { key: 'all', title: 'All', color: 'muted' },
    { key: 'verified', title: 'Verified', color: 'success' },
    { key: 'needs_review', title: 'Needs review', color: 'warning' },
    { key: 'rejected', title: 'Rejected', color: 'danger' },
];

export const DocumentForensicsFieldStatuses = {
    matched: { title: 'Match', className: 'text-success', icon: 'ri-checkbox-circle-fill' },
    unclear: { title: 'Unclear', className: 'text-warning', icon: 'ri-error-warning-fill' },
    mismatched: { title: 'Mismatch', className: 'text-danger', icon: 'ri-close-circle-fill' },
    not_verified: { title: 'Not verified', className: 'text-danger', icon: 'ri-close-circle-line' },
    no_match: { title: 'No match', className: 'text-danger', icon: 'ri-close-circle-fill' },
    partial: { title: 'Partial match', className: 'text-warning', icon: 'ri-error-warning-fill' },
    low_confidence: { title: 'Low confidence', className: 'text-warning', icon: 'ri-error-warning-line' },
};

export const CyberSecurityStatuses = {
    passed: {
        title: 'Passed',
        className: 'text-success',
        badge: 'badge-soft-success',
        icon: 'ri-checkbox-circle-fill',
        color: 'success',
    },
    warning: {
        title: 'Warning',
        className: 'text-warning',
        badge: 'badge-soft-warning',
        icon: 'ri-error-warning-fill',
        color: 'warning',
    },
    failed: {
        title: 'Failed',
        className: 'text-danger',
        badge: 'badge-soft-danger',
        icon: 'ri-close-circle-fill',
        color: 'danger',
    },
    critical: {
        title: 'Critical',
        className: 'text-danger',
        badge: 'badge-soft-danger',
        icon: 'ri-close-circle-fill',
        color: 'danger',
    },
};

export const CallAttemptStatuses = {
    answered: { title: 'Answered', className: 'badge-soft-success' },
    not_answered: { title: 'Not answered', className: 'badge-soft-danger' },
    voicemail: { title: 'Voicemail', className: 'badge-soft-warning' },
    in_progress: { title: 'In progress', className: 'badge-soft-info' },
    failed: { title: 'Failed', className: 'badge-soft-danger' },
};

export const CallCheckStatuses = {
    valid: { title: 'Valid', className: 'text-success', icon: 'ri-checkbox-circle-fill' },
    verified: { title: 'Verified', className: 'text-success', icon: 'ri-checkbox-circle-fill' },
    not_verified: { title: 'Not verified', className: 'text-danger', icon: 'ri-close-circle-fill' },
    not_checked: { title: 'Not checked', className: 'text-muted', icon: 'ri-checkbox-blank-circle-line' },
    failed: { title: 'Failed', className: 'text-danger', icon: 'ri-close-circle-fill' },
};

export const BidRiskLevels = {
    Low: { title: 'Low', className: 'badge-soft-success' },
    Medium: { title: 'Medium', className: 'badge-soft-warning' },
    High: { title: 'High', className: 'badge-soft-danger' },
};
